module.exports = __webpack_public_path__ + "static/img/xueweititle.4e1fc96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xueweititle.png
// module id = BhyQ
// module chunks = 1